import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import companyLogo from '../images/logo.png';
import { useIsAuthenticated, useMsal } from "@azure/msal-react"; // MSAL imports

const Navbar = () => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const location = useLocation();
  const isFlightTrackerPage = location.pathname.startsWith('/flight_tracker');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    instance.logoutRedirect({
        postLogoutRedirectUri: "/", // Redirect to home page after logout
    }).catch(e => {
        console.error("Logout redirect failed: ", e);
    });
  }

  return (
    <nav className="navbar">
      <div className="navbar-brand-container">
        <Link to="/" className="navbar-logo-link">
          <img src={companyLogo} alt="Company Logo" className="navbar-logo" />
        </Link>
        {isFlightTrackerPage && (
          <span className="navbar-title-text">Flights</span>
        )}
      </div>
      <ul className={`navbar-nav ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(false)}>
        {isFlightTrackerPage ? (
          <>
            <li className="nav-item">
              <Link to="/flight_tracker/flight_notes" className="nav-link">Notes</Link>
            </li>
            <li className="nav-item">
              <Link to="/flight_tracker/graphs" className="nav-link">Graphs</Link>
            </li>
          </>
        ) : (
          <>
            <li className="nav-item">
              <Link to="/flight_tracker/read" className="nav-link">Flights</Link>
            </li>
            <li className="nav-item">
              <Link to="/products" className="nav-link">Products</Link>
            </li>
          </>
        )}
        {isAuthenticated && (
          <li className="nav-item">
            <button onClick={handleLogout} className="nav-link logout-button" aria-label="Exit">
              ❌
            </button>
          </li>
        )}
      </ul>

      {/* Burger icon aligned to right */}
      <button
        className={`burger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(prev => !prev)}
        aria-label="Toggle navigation menu"
      >
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
};

export default Navbar;
